import React from 'react';
import { Modal } from 'antd';
import { Button } from '@/components/Button';
import styles from './ExitSessionModal.module.scss';

interface ExitSessionModalProps {
  onStay: () => void;
  onSaveAndExit: () => void;
}

/**
 * Mirrors HtsQuestionnaire's HtsExitModal exactly (plain `centered`, no
 * rootClassName override, shared Button for actions) — the previous
 * implementation used antd's imperative `modal.confirm()` with a custom
 * rootClassName that hand-rolled conflicting centering on top of `centered`,
 * which is why it used to render near the top of the viewport instead of
 * centered.
 */
export const ExitSessionModal: React.FC<ExitSessionModalProps> = ({ onStay, onSaveAndExit }) => (
  <Modal open closable={false} maskClosable={false} footer={null} width={420} centered>
    <h3 className={styles.confirmTitle}>Save & exit?</h3>
    <p className={styles.confirmBody}>
      Your progress is saved — you can resume this session anytime from Sessions.
    </p>
    <div className={styles.confirmActions}>
      <Button appearance="outline" onClick={onStay}>Cancel</Button>
      <Button appearance="solid" accent="green" onClick={onSaveAndExit}>Save & Exit</Button>
    </div>
  </Modal>
);
